import { Card } from "reactstrap";
import { useAppSelector } from "../../../../../reduxToolkit/hooks";
import MailHeader from "./MailHeader";
import MailBody from "./MailBody";

const InterviewMail = () => {

  const { interviewEmail } = useAppSelector((state) => state.letterBox);

  return (

    <Card className={`message-body email-read ${interviewEmail ? "show" : "hide"}`}>
      <MailHeader />
      <MailBody/> 
    </Card> 
  );
};

export default InterviewMail;